import { SimpleGrid, Image,Box } from "@chakra-ui/react"

export const GithubStats=()=>{
    return(
        <>
        <SimpleGrid columns={[1,2]} gap='10px' m={'auto'} mt={{base:'10px', md:'20px'}}>
            <Box m='auto' w={'80%'}>
            <Image id="github-streak-stats" w={'100%'} src="https://github-readme-streak-stats.herokuapp.com?user=RutuvikP&theme=tokyonight"/>
            </Box>
            <Box m='auto' w={'80%'}>
            <Image id="github-stats-card" w={'100%'} src="https://github-readme-stats.vercel.app/api?username=rutuvikp&theme=tokyonight&show_icons=true"/>
            </Box>
        </SimpleGrid>
        <SimpleGrid columns={[1]} mt={{base:'10px', md:'20px'}}>
        <Box m='auto' w={{base:'80%', sm:'40%', md:'40%'}} mb='20px'>
                <Image id="github-top-langs" w={'100%'} src="https://github-readme-stats.vercel.app/api/top-langs/?username=rutuvikp&layout=compact&theme=tokyonight"/>
            </Box>
        </SimpleGrid>
        </>
    )
};